module.exports = __webpack_public_path__ + "static/img/b2-2-1.5dc0f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b2-2-1.png
// module id = GqGB
// module chunks = 1